var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"bf95f105a0fa4f08384949add4f4a854abf0f465"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["appsmith@appsmith"]={id:"bf95f105a0fa4f08384949add4f4a854abf0f465"};
      